import { render, staticRenderFns } from "./aws-textract.vue?vue&type=template&id=7bd4a83d&scoped=true"
import script from "./aws-textract.vue?vue&type=script&lang=js"
export * from "./aws-textract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd4a83d",
  null
  
)

export default component.exports